<template>
  <div class="layer-ui opacity-95" :class="{ 'has-banner': isDeletedProgramMode }">
    <div v-if="isDeletedProgramMode" class="deleted-program-banner">
      This tower is read-only: the linked program or one of its policies has been deleted.
    </div>
    <div class="flex flex-col gap-4 min-h-0">
      <MenuActions />
      <Inspector/>
    </div>
    <ToolSelector />
    <LimitPremiumCounter />
    <NavigationActions />
    <ProgramsLibraryButton />
    <CanvasActions />
    <div class="overlay" :style="{ display: editMode ? 'none' : '' }">Select an Account and Program to Begin</div>
  </div>
</template>

<script lang="ts">
import ToolSelector from './ToolSelector.vue';
import Inspector from './Inspector.vue';
import ProgramsLibraryButton from './ProgramsLibraryButton.vue';
import NavigationActions from './NavigationActions.vue';
import Store from '@/store';
import CanvasActions from '@/views/tower/v2/CanvasActions.vue';
import MenuActions from '@/views/tower/v2/MenuActions.vue';
import LimitPremiumCounter from './LimitPremiumCounter.vue';

export default {
  name: 'UILayer',
  components: {
    MenuActions,
    CanvasActions,
    ToolSelector,
    LimitPremiumCounter,
    Inspector,
    NavigationActions,
    ProgramsLibraryButton,
  },
  computed: {
    editMode() {
      return Store.state.towerCanvasState.editMode;
    },
    isDeletedProgramMode() {
      return Store.state.towerCanvasState.isDeletedProgramMode;
    },
  },
};
</script>

<style scoped>
.layer-ui {
  display: grid;
  justify-items: start;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 60px;
  grid-gap: 4px;
  align-content: start;
  position: absolute;
  height: 100%;
  width: 100%;
  pointer-events: none;
  z-index: var(--zindex-layerui);
}

.tools {
  display: flex;
  flex-direction: column;
}

.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: none;
}

.layer-ui.has-banner {
  padding-top: 40px;
}

.deleted-program-banner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(220, 38, 38, 0.9);
  color: white;
  text-align: center;
  padding: 8px 16px;
  z-index: 10;
  pointer-events: none;
  font-weight: 500;
}
</style>
